import withReducer from '../../store/withReducer'
import EkgReviewEkgRecording from './container'
import reducer from './module'

export default withReducer('ekgReviewEkgRecording', reducer)(EkgReviewEkgRecording)



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReviewEkgRecording/index.js